import { render, staticRenderFns } from "./PricingAccordionItem.vue?vue&type=template&id=cdb1dbdc&scoped=true&"
import script from "./PricingAccordionItem.vue?vue&type=script&lang=js&"
export * from "./PricingAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingAccordionItem.vue?vue&type=style&index=0&id=cdb1dbdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb1dbdc",
  null
  
)

export default component.exports